export default __webpack_public_path__ + "static/media/layOnRock.84b26127.jpg";